import Tags from '@material-ui/icons/Subtitles'
import List from '@material-ui/icons/ViewList'

export const TagIcon = Tags
export const TagListIcon = List
